const GLightbox = require('glightbox');

(() => {
    const triggers = document.querySelectorAll('[data-gallery-lightbox]');
    if (!triggers.length) return;

    const lightbox = GLightbox({
        selector: '[data-gallery-lightbox]',
        touchNavigation: true,
        keyboardNavigation: true,
        loop: false,
        autoplayVideos: false,
        plyr: {
            css: '/vendor/plyr/plyr.css',
            js: '/vendor/plyr/plyr.js',
            config: {
                autoplay: false, ratio: '16:9', loadSprite: false, iconUrl: '/vendor/plyr/plyr.svg',
                youtube: { noCookie: true, rel: 0 },
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen']
            }
        },
        closeOnOutsideClick: true,
        moreLength: 0,
        descPosition: 'bottom',
        openEffect: 'fade',
        closeEffect: 'fade',
        slideEffect: 'slide'
    });

    document.querySelectorAll('[data-gallery-open]').forEach((button) => {
        button.addEventListener('click', () => {
            const trigger = document.getElementById(button.getAttribute('data-gallery-open'));
            trigger?.click();
        });
    });

    window.addEventListener('pageshow', () => {
        lightbox.reload();
    });
})();
